const server = {
  // baseUrl: 'http://192.168.2.196:3000',
  // baseMongoUrl: 'http://192.168.2.196:3000',
  baseUrl: 'http://api.devaha-llc.com',
  baseUrlProd: 'https://api.aha-llc.com',
  baseMongoUrl: 'https://harold-api.sandboxdevelopment.in',
  prod: "",
};
export function baseUrlPostGres() {
  return server.baseUrlProd 
  // if(process.env.REACT_APP_URL === 'prod'){
  //     return server.prod
  // } else {
  // }
}

export function baseUrlMongoDb() {
  return server.baseUrlProd;
  // if(process.env.REACT_APP_URL === 'prod'){
  //     return server.prod
  // } else {
  // }
}
